import { render, staticRenderFns } from "./Truck.vue?vue&type=template&id=5103c63f&scoped=true"
import script from "./Truck.vue?vue&type=script&lang=ts"
export * from "./Truck.vue?vue&type=script&lang=ts"
import style0 from "./Truck.vue?vue&type=style&index=0&id=5103c63f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103c63f",
  null
  
)

export default component.exports